<div class="new-connection" [formGroup]="addAccountForm" (keydown.Space)="$event.stopPropagation()">
  <div class="new-connection_step-container input-container">
    <div class="new-connection_step-title">1. Account Nickname</div>
    <input
      formControlName="name"
      type="text"
      class="input-container_input input-container_input--thin"
      [ngClass]="{'error': duplicateNameValue}"
      (blur)="validateName()"
    />
  </div>
  <div class="new-connection_step-container" *ngIf="componentData.channelType === 'walmart' || componentData.channelType === 'wayfair'">
    <div class="new-connection_step-title">
      2. {{componentData.channelType === 'walmart' ? "Find your keys under the 'My API Key' section": "Create nineyard as a new app with status as 'Production'"}}
    </div>
    <app-button (click)="openWalmartPage()" [buttonSize]="'action'"
      >Create Key</app-button
    >
  </div>
  <div class="new-connection_step-container">
    <div class="new-connection_step-title">
     {{(componentData.channelType === "walmart" || componentData.channelType === 'wayfair') ? "3. " :"2. "}} {{keyLabelText}}.
    </div>

    <div class="input-container mb-3" *ngIf="componentData.channelType == 'WooCommerce'">
      <label for="" class="input-container_label">Shop URL</label>
      <input
        type="text"
        formControlName="key"
        (blur)="validateKey()"
        [ngClass]="{'error': duplicateStoreClientValue}"
        class="input-container_input input-container_input--thin"
        [placeholder]="'storename.com'"
       
      />
    </div>
    <div class="new-connection_data-inputs">
      <div class="input-container" *ngIf="componentData.channelType !== 'WooCommerce'">
        <label for="" class="input-container_label">{{componentData.channelType == 'BigCommerce' ? 'Store Hash' : componentData.channelType !== 'shopify' ? 'Client ID' : 'Shop URL'}}</label>
        <input
          type="text"
          formControlName="key"
          (blur)="validateKey(componentData.channelType == 'BigCommerce' ? true : null)"
          [ngClass]="{'error': duplicateStoreClientValue}"
          class="input-container_input input-container_input--thin"
          [placeholder]="componentData.channelType == 'shopify' ? 'storename.myshopify.com' : ''"
         
        />
      </div>

      <div class="input-container" *ngIf="componentData.channelType !== 'WooCommerce'">
        <label for="" class="input-container_label">{{(componentData.channelType !== 'shopify' && componentData.channelType !== 'BigCommerce') ? 'Client Secret' : 'Access Token'}}</label>
        <input
          formControlName="secret"
          type="text"
          class="input-container_input input-container_input--thin"
          (blur)="validateSecret()"
          [ngClass]="{'error': duplicateKeyValue}"
        />
      </div>
      <ng-container *ngIf="componentData.channelType == 'WooCommerce'">
        <div class="input-container">
          <label for="" class="input-container_label">Consumer Key</label>
          <input
            formControlName="consumerKey"
            type="text"
            class="input-container_input input-container_input--thin"
          />
        </div>
        <div class="input-container">
          <label for="" class="input-container_label">Consumer Secret</label>
          <input
            formControlName="consumerSecret"
            type="text"
            class="input-container_input input-container_input--thin"
          />
        </div>
      </ng-container>
    </div>
  </div>

  <div class="new-connection_step-container" *ngIf="componentData.channelType === 'wayfair'">
    <div class="new-connection_step-title">
     4. Enter SandBox Client and SandBox Secret  provided by your marketplace.
    </div>
    <div class="new-connection_data-inputs">
    <div class="input-container" >
      <label for="" class="input-container_label">SandBox Client</label>
      <input
        type="text"
        formControlName="sandboxClient"
        class="input-container_input input-container_input--thin"
        (blur)="validateWayFair('sandboxClient')"
       
      />
    </div>
      <div class="input-container">
        <label for="" class="input-container_label">SandBox Secret</label>
        <input
          type="text"
          formControlName="sandboxSecret"
          class="input-container_input input-container_input--thin"
          (blur)="validateWayFair('sandboxSecret')"
        />
      </div>
    </div>
  </div>
  <div class="new-connection_step-container input-container" *ngIf="componentData.channelType === 'walmart'">
    <div class="new-connection_step-title">4. Marketplace</div>
    <div>
        <select formControlName="walmartRegion" type="text" class="input-container_input input-container_input--thin" placeholder="test">
            <option value="" disabled selected hidden>Select</option>
            <option [value]="market.marketplaceid" *ngFor="let market of walmartMarkets">
                {{ market.name }}
            </option>
        </select>
    </div>
</div>
  <div class="new-connection_note"><i class="fas fa-info-circle"></i> Additional integration monthly fee may apply</div>
  <div class="new-connection_action">
    <app-button (click)="cancel()" [buttonStyle]="'wire'">Cancel</app-button>
    <app-button
      [spin]="spinLoader"
      [isDisabled]="!addAccountForm.valid || duplicateNameValue || duplicateKeyValue || duplicateStoreClientValue"
      (click)="saveNewMarketplace()"
      >Save</app-button
    >
  </div>
</div>
